// extracted by mini-css-extract-plugin
export default {"container":"HobU8","text":"_3INOV","clamp":"_81XUh"};